module.exports = __webpack_public_path__ + "img/juheyuan.16f1477.png";